<template>
  <div class="isis-event p-1 overflow-hidden">
    <p class="text-left truncate" :data-calendar-id="eventId">
      {{ eventTitle }}
    </p>
    <p class="text-left mt-1 min-h-[16px]">{{ arg.timeText }}</p>
    <div
      class="absolute bottom-1 right-1"
      v-if="this.arg.event.extendedProps.category === 'schedule'"
    >
      <i
        v-if="isDateBeforeToday && !isAttendanceComplete"
        class="fas fa-check text-[fff]"
      ></i>
      <i
        v-if="isDateBeforeToday && isAttendanceComplete"
        class="fas fa-check-double text-[fff]"
      ></i>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import { EVENT_TYPES } from "./event-utils";

export default {
  props: ["arg"],
  computed: {
    eventId() {
      return this.arg.event.extendedProps._id;
    },
    eventTitle() {
      const isAllDay = this.arg.event.allDay;

      return isAllDay
        ? `${this.arg.event.title} - ${this.$t("schedule.all_day")}`
        : this.arg.event.title;
    },
    ...mapGetters("user", { userTz: "timezone" }),
    isDateBeforeToday() {
      return (
        new Date(this.arg.event.extendedProps.end).toISOString() <
        new Date().toISOString()
      );
    },
    isAttendanceComplete() {
      if (this.arg.event.extendedProps.type === EVENT_TYPES.meetingEvent) {
        return !this.arg.event.extendedProps.attendances.length;
      }
      if (this.arg.event.extendedProps.type === EVENT_TYPES.classEvent) {
        return this.arg.event.extendedProps.attendances.length;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
